import { Component, OnInit } from '@angular/core';
import { CurrencyMaskInputMode } from 'ngx-currency';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-onboarding-amount',
    templateUrl: './amount.component.html',
    styleUrls: ['./amount.component.scss'],
})
export class AmountComponent implements OnInit {
    amount;
    currencySymbol = '$';
    recurringSymbol = '$';
    isRecurring = false;
    isRecurringSet = false;
    

    currencyCodes = [
        {
            symbol: '$',
            code: 'USD',
        },
        // {
        //     symbol: 'N',
        //     code: 'NGN',
        // },
    ];

    currencyOptions = {
        align: 'left',
        allowNegative: false,
        allowZero: false,
        decimal: '.',
        precision: 2,
        prefix: '',
        suffix: '',
        thousands: ',',
        nullable: true,
        min: null,
        max: null,
        inputMode: CurrencyMaskInputMode.NATURAL,
    };
    errMsg: string;

    submitRecurring(e) {
        e.preventDefault();
        this.isRecurringSet = true;
    }

    setAsRecurring(e) {
        this.isRecurring = e.target.checked;
    }

    setRecurringSymbol(currency) {
        this.recurringSymbol = currency.symbol;
    }

    setSymbol(currency) {
        this.currencySymbol = currency.symbol;
    }

    resetRecurring() {
        this.isRecurringSet = false;
    }

    updateAmount(e) {
        localStorage.setItem('advAmount', this.amount.toString());
    }

    check(){
        if (this.amount <= 100)
            this.errMsg="Amount must be greater than $100";
        else
            this.errMsg = '';
    }

    constructor(private toastr: ToastrService) {}

    ngOnInit() {}
}
